import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import Avatar         from '@material-ui/core/Avatar'
import Card           from '@material-ui/core/Card'
import CardActions    from '@material-ui/core/CardActions'
import CardContent    from '@material-ui/core/CardContent'
import CardHeader     from '@material-ui/core/CardHeader'
import Collapse       from '@material-ui/core/Collapse'
import Divider        from '@material-ui/core/Divider'
import Grid           from '@material-ui/core/Grid'
import IconButton     from '@material-ui/core/IconButton'
import Edit           from '@material-ui/icons/Edit'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import styled from 'styled-components'

import { Company }      from '../../api'
import genRngHex        from '../../utils/rng-hex'
import { LabelledText } from '../atoms'
import { ContactCard }  from './index'

const ExpandMore = styled(ExpandMoreIcon)`
  transform: rotate(${({ isExpanded }: { isExpanded: boolean }) => isExpanded ? '180' : '0' }deg);
  transition: ${
  ({ theme: { transitions: { create, duration } } }) =>
    create('transform', { duration: duration.shortest })
  }
`

const ExpandMoreIconButton = styled(IconButton)`
  margin-left: auto;
`

interface CompanyCardProps {
  onEditClick: () => void
  onExpandClick: () => void
  expanded: boolean
  /*
   TODO: redux for this exists
   onDelete: (company: Company) => void
   */
  company: Company
}

const initState = { isExpanded: false }

class CompanyCard extends React.Component<CompanyCardProps, typeof initState> {
  public state = initState

  public render () {
    const
      {
        onExpandClick,
        expanded,
        company:
          {
            contacts,
            name,
            mobile,
            address,
            cif,
            phone,
            contactName,
          },
      } = this.props

    const initials = name.split(' ').map(word => word[ 0 ] ? word[ 0 ].toUpperCase() : '')

    const bgColor = genRngHex(name)

    return (
      <Card style={{ height: '100%' }}>
        <Grid style={{ height: '100%' }} container direction={'column'}>
          <Grid item>
            <CardHeader
              avatar={
                <Avatar style={{ background: bgColor }}>
                  {initials[ 0 ] + (initials[ 1 ] || '')}
                </Avatar>
              }
              title={name}
              subheader={contactName}
            />
          </Grid>
          <Grid item style={{ flex: 1 }}>
            <CardContent>
              <Grid container spacing={40}>
                <Grid item>
                  <LabelledText label={<FormattedMessage id={'labels.cif'} />}>
                    {cif}
                  </LabelledText>
                </Grid>
                <Grid item>
                  <LabelledText label={<FormattedMessage id={'labels.mobile'} />}>
                    <a href={`tel:${mobile}`}>{mobile}</a>
                  </LabelledText>
                </Grid>
                {phone && (
                  <Grid item>
                    <LabelledText label={<FormattedMessage id={'labels.phone'} />}>
                      {phone}
                    </LabelledText>
                  </Grid>
                )}
                <Grid item xs={12}>
                  <LabelledText label={<FormattedMessage id={'labels.address'} />}>
                    {address}
                  </LabelledText>
                </Grid>
              </Grid>
            </CardContent>
          </Grid>
          <Grid item>
            <CardActions>
              <IconButton onClick={this.props.onEditClick}>
                <Edit />
              </IconButton>
              {
                contacts && Boolean(contacts.length) && (
                  <ExpandMoreIconButton onClick={onExpandClick}>
                    <ExpandMore isExpanded={expanded} />
                  </ExpandMoreIconButton>
                )
              }
            </CardActions>
          </Grid>
          {contacts && Boolean(contacts.length) && (
            <Collapse
              mountOnEnter
              unmountOnExit
              in={expanded}
            >
              <CardHeader title={<FormattedMessage id={'labels.contacts'} />} />
              {
                contacts && Boolean(contacts.length) && contacts.map((contact, i) => (
                    <React.Fragment key={i}>
                      <ContactCard {...contact} />
                      {i < contacts.length && <Divider />}
                    </React.Fragment>
                  )
                )
              }
            </Collapse>
          )
          }
        </Grid>
      </Card>
    )
  }
}

export default CompanyCard



// WEBPACK FOOTER //
// ./src/components/molecules/CompanyCard.tsx